<template>
  <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
    <!-- header -->
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-xl font-semibold text-gray-900">إدارة الجلسات</h1>
      </div>
    </div>

    <!-- region selector + add button -->
    <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-3 lg:grid-cols-6 items-end">
      <!-- selector -->
      
        <h2 class="text-lg font-medium text-gray-900 text-left">الرجاء اختيار المنطقة</h2>
        <select
          v-model="regionId"
          @change="getAllMasterAthan"
          class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
        >
          <option disabled value="">الرجاء اختيار المنطقة</option>
          <option
            v-for="region in masterRegionsList"
            :key="region.id"
            :value="region.id"
          >
            {{ region.regionNameAr }}
          </option>
        </select>
      

      <!-- Add Country Button -->
      <div class="text-left">
        <button
          @click="openAddRegionPopup"
          class="px-4 py-2  text-white rounded-md bg-customHafadhColor"
        >
          إضافة منطقة
        </button>
        
      </div>
    </div>

    <!-- sessions table (unchanged) -->
    <div class="mt-8 flex flex-col">
      <div class="sm:flex-auto">
        <h1 class="text-lg font-medium text-gray-900">
          الجلسات في منطقة: {{ regionNameAr }}
        </h1>
        
        <!-- Info about the new feature -->
        <div class="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-md">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="mr-3">
              <h3 class="text-sm font-medium text-blue-800">ميزة محسّنة: إدارة منفصلة لأوقات الجلسات</h3>
              <div class="mt-2 text-sm text-blue-700">
                <p>يمكن إدارة أوقات الجلسات الفردية من قائمة "إدارة أوقات الجلسات" للتحكم الدقيق.</p>
              </div>
            </div>
          </div>
        </div>
        
        <button
          @click="openAddAthanPopup()"
          class="px-3 py-1  text-white rounded-md   py-2 bg-customHafadhColor mt-3"
        >
          + أضف توقيت أذان
        </button>
        <br>
      </div>
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-customHafadhColor">
              <thead class="bg-customHafadhColor text-center">
                <tr>
                  <th class="py-3.5 pr-4 pl-3 text-right text-sm font-semibold text-gray-900 sm:pr-6">الصلاة</th>
                  <th class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">وقت الأذان</th>
                  <th class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">المنطقة</th>
                  <th class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">الجلسة بعد (دقيقة)</th>
                  <th class="px-3 py-3.5 text-right text-sm font-semibold text-gray-900">الإجراءات</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="data in masterAthanData" :key="data.id">
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900">{{ data.prayerName }}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ data.prayerTime }}</td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900">{{ data.regionNameAr }}</td>
                  <td class="whitespace-nowrap py-4 pr-4 pl-3 text-sm font-medium text-gray-900">
                    <input v-model="data.sessionStartAfter" type="number" class="w-20 p-1 border rounded" min="1" />
                  </td>
                  <td class="px-3 py-4 text-center">
                   <button
                     @click="deleteAthan(data.id)"
                     class="text-red-600 hover:text-red-800"
                   >حذف</button>
                 </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="mt-4 text-left">
        <button 
          @click="updateStartSessions" 
          :disabled="isUpdating"
          class="px-4 py-2 bg-customHafadhColor text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        >
          <span v-if="isUpdating" class="animate-spin">⏳</span>
          <span v-else>✅</span>
          {{ isUpdating ? 'جاري التحديث...' : 'تحديث إعدادات الصلاة' }}
        </button>
      </div>
    </div>

    <!-- Add Region Popup -->
    <div v-if="showAddRegionPopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div class="bg-white rounded-lg shadow-xl p-6 w-96">
        <h3 class="text-lg font-medium text-gray-900 mb-4">إضافة منطقة جديدة</h3>

        <div class="space-y-3">
          <div>
            <label class="block text-sm font-medium text-gray-700">رمز الدولة</label>
            <input v-model="newRegion.countryCode" type="text" class="w-full p-2 border rounded" />
            <span v-if="errors.countryCode" class="text-red-500 text-xs">{{ errors.countryCode }}</span>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">رمز المنطقة</label>
            <input v-model="newRegion.regionCode" type="text" class="w-full p-2 border rounded" />
            <span v-if="errors.regionCode" class="text-red-500 text-xs">{{ errors.regionCode }}</span>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">اسم المنطقة (عربي)</label>
            <input v-model="newRegion.regionNameAr" type="text" class="w-full p-2 border rounded" />
            <span v-if="errors.regionNameAr" class="text-red-500 text-xs">{{ errors.regionNameAr }}</span>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700">اسم المنطقة (إنجليزي)</label>
            <input v-model="newRegion.regionNameEn" type="text" class="w-full p-2 border rounded" />
            <span v-if="errors.regionNameEn" class="text-red-500 text-xs">{{ errors.regionNameEn }}</span>
          </div>
        </div>

        <div class="mt-6 flex justify-end space-x-2">
          <button @click="closeAddRegionPopup" class="px-4 py-2 bg-gray-300 rounded">إلغاء</button>
          <button @click="submitNewRegion" class="px-4 py-2 bg-blue-600 text-white rounded">حفظ</button>
        </div>
      </div>
    </div>
        <!-- +— Add Athan-Time Popup -->
    <div v-if="showAddAthanPopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div class="bg-white rounded-lg shadow-xl p-6 w-96">
        <h3 class="text-lg font-medium text-gray-900 mb-4">إضافة توقيت أذان جديد</h3>

        <div class="space-y-3">
          <div>
            <label class="block text-sm font-medium">المنطقة *</label>
            <select
              v-model="newAthan.regionId"
              @change="loadPrayerTimeForNewAthan"
              class="w-full p-2 border rounded"
            >
              <option disabled value="">اختر المنطقة</option>
              <option v-for="region in masterRegionsList" :key="region.id" :value="region.id">
                {{ region.regionNameAr }}
              </option>
            </select>
            <span v-if="athanErrors.regionId" class="text-red-500 text-xs">{{ athanErrors.regionId }}</span>
          </div>
          <div>
            <label class="block text-sm font-medium">اسم الصلاة *</label>
           <select
              v-model="newAthan.prayerName"
              @change="loadPrayerTimeForNewAthan"
              class="w-full p-2 border rounded">
              <option disabled value="">اختر الصلاة</option>
              <option value="FAJR">الفجر</option>
              <option value="DHUHR">الظهر</option>
              <option value="ASR">العصر</option>
              <option value="MAGHRIB">المغرب</option>
              <option value="ISHA">العشاء</option>
            </select>
            <span v-if="athanErrors.prayerName" class="text-red-500 text-xs">{{ athanErrors.prayerName }}</span>
          </div>
          <div>
            <label class="block text-sm font-medium">وقت الأذان *</label>
            <input 
              v-model="newAthan.prayerTime" 
              type="time" 
              class="w-full p-2 border rounded"
              :disabled="loadingPrayerTime"
            />
            <span v-if="loadingPrayerTime" class="text-xs text-blue-500 mt-1">جاري جلب وقت الصلاة...</span>
            <span v-else-if="athanErrors.prayerTime" class="text-red-500 text-xs">{{ athanErrors.prayerTime }}</span>
            <span v-else-if="newAthan.prayerTime" class="text-xs text-green-500 mt-1">✓ تم جلب وقت الصلاة تلقائياً</span>
          </div>
          <div>
            <label class="block text-sm font-medium">جلسة بعد (دقائق)</label>
            <input v-model="newAthan.sessionStartAfter" type="number" min="1" class="w-full p-2 border rounded" />
            <span v-if="athanErrors.sessionStartAfter" class="text-red-500 text-xs">{{ athanErrors.sessionStartAfter }}</span>
            <p class="text-xs text-gray-500 mt-1">عدد الجلسات يُدار من قائمة "إدارة أوقات الجلسات"</p>
          </div>
        </div>

        <div class="mt-6 flex justify-end space-x-2">
          <button @click="closeAddAthanPopup()" class="px-4 py-2 bg-gray-300 rounded">إلغاء</button>
          <button @click="submitNewAthan()" class="px-4 py-2 bg-blue-600 text-white rounded">حفظ</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import url from '@/url';
import axios from 'axios';
import { defineComponent } from 'vue';

class MasterAthanDto {
  constructor(data) {
    this.id = data.id;
    this.prayerName = data.prayerName;
    this.prayerTime = data.prayerTime;
    this.regionNameAr = data.regionNameAr;
    this.sessionStartAfter = data.sessionStartAfter;
    // totalClass removed - session count is managed individually
  }
}
class MasterRegionsDto {
  constructor(data) {
    this.id = data.id;
    this.countryCode = data.countryCode;
    this.regionCode = data.regionCode;
    this.regionNameAr = data.regionNameAr;
    this.regionNameEn = data.regionNameEn;
  }
}

export default defineComponent({
  data() {
    return {
      masterAthanData: [],
      masterRegionsList: [],
      regionId: '',
      regionNameAr: '',

      // popup state
      showAddAthanPopup: false,
      newAthan: { regionId: '', prayerName: '', prayerTime: '', sessionStartAfter: null },
      athanErrors: {},
      loadingPrayerTime: false,
      showAddRegionPopup: false,
      newRegion: {
        countryCode: '',
        regionCode: '',
        regionNameAr: '',
        regionNameEn: ''
      },
      errors: {},
      
      // loading state
      isUpdating: false
    };
  },

  mounted() {
    this.masterRegions();
  },

  methods: {
    // load regions
    async masterRegions() {
      try {
        const resp = await axios.get(process.env.VUE_APP_SERVICE_URL + url.master_regions, {
          headers: { 'X-Authorization': localStorage.getItem('token') }
        });
        this.masterRegionsList = resp.data.result.data.map(d => new MasterRegionsDto(d));
        if (this.masterRegionsList.length) {
          this.regionId = this.masterRegionsList[0].id;
          this.getAllMasterAthan();
        }
      } catch (e) {
        console.error(e);
      }
    },

     // delete single athan-time by id
       async deleteAthan(athanId) {
         if (!confirm('هل أنت متأكد أنك تريد حذف هذا التوقيت؟')) return;
         try {
           await axios.delete(
             `${process.env.VUE_APP_SERVICE_URL + url.Delete_athan_time}${this.regionId}/${athanId}`,
             {
               headers: {
                 'X-Authorization': localStorage.getItem('token')
               }
             }
           );
           // remove from local array
           this.masterAthanData = this.masterAthanData.filter(a => a.id !== athanId);
           alert('تم الحذف بنجاح');
         } catch (e) {
           console.error(e);
           alert('فشل الحذف.');
         }
       },

    // load athan times
    async getAllMasterAthan() {
      try {
        const resp = await axios.get(
          `${process.env.VUE_APP_SERVICE_URL + url.master_athan_time}${this.regionId}`,
          { headers: { 'X-Authorization': localStorage.getItem('token') } }
        );
        this.regionNameAr = this.masterRegionsList.find(r => r.id === this.regionId)?.regionNameAr || '';
        this.masterAthanData = resp.data.result.data.map(d => new MasterAthanDto(d)).sort((a, b) => a.id - b.id);
      } catch (e) {
        console.error(e);
      }
    },

    // update prayer configurations (simplified)
    async updateStartSessions() {
        let request = [];
        
        // Prepare the request data (only sessionStartAfter is needed)
        this.masterAthanData.forEach(data => {
            let requestAthanTimes = {
                "id": data.id,
                "sessionStartAfter": data.sessionStartAfter
                // totalClass removed - session count is managed individually
            }
            request.push(requestAthanTimes);
        });
        
        // Show confirmation dialog with simplified messaging
        const confirmed = confirm(
            "🔄 تحديث إعدادات الصلاة\n\n" +
            "✅ سيتم تحديث إعدادات أوقات الأذان (وقت بداية الجلسة بعد الأذان)\n" +
            "📝 ملاحظة: عدد الجلسات يُدار بشكل منفصل من قائمة \"إدارة أوقات الجلسات\"\n\n" +
            "هل تريد المتابعة؟"
        );
        
        if (!confirmed) return;
        
        try {
            // Show loading state
            this.isUpdating = true;
            
            console.log("Sending prayer configuration update:", request);
            
            // Use the simplified prayer configuration endpoint
            const response = await axios.post(
                process.env.VUE_APP_SERVICE_URL + url.update_prayer_configurations + this.regionId,
                request,
                {
                    headers: {
                        'X-Authorization': localStorage.getItem('token'),
                    },
                }
            );
            
            if (response.data?.result?.data) {
                const result = response.data.result.data;
                
                let successMessage = `✅ تم تحديث إعدادات الصلاة في منطقة ${this.regionNameAr} بنجاح!\n\n`;
                successMessage += `📊 ملخص التحديثات:\n`;
                successMessage += `• عدد أوقات الأذان المحدثة: ${result.updatedAthanTimes || 0}\n\n`;
                successMessage += `💡 لإدارة أوقات الجلسات، انتقل إلى قائمة "إدارة أوقات الجلسات"`;
                
                alert(successMessage);
                
                // Refresh the data
                await this.getAllMasterAthan();
                
            } else {
                alert('✅ تم تحديث إعدادات الصلاة بنجاح!\n\n💡 لإدارة أوقات الجلسات، انتقل إلى قائمة "إدارة أوقات الجلسات"');
                await this.getAllMasterAthan();
            }
            
            console.log("Update response:", response);
            
        } catch (error) {
            console.error("Error updating sessions:", error);
            
            let errorMessage = "❌ حدث خطأ أثناء تحديث الجلسات\n\n";
            
            if (error.response?.data?.mesAr) {
                errorMessage += error.response.data.mesAr;
            } else if (error.response?.data?.message) {
                errorMessage += error.response.data.message;
            } else if (error.response?.status === 500) {
                errorMessage += "خطأ في الخادم - يرجى المحاولة مرة أخرى لاحقاً";
            } else if (error.response?.status === 404) {
                errorMessage += "الـ endpoint غير موجود - يرجى التأكد من تحديث النظام";
            } else {
                errorMessage += "خطأ غير متوقع في النظام";
            }
            
            errorMessage += "\n\n💡 تأكد من أن النظام محدث إلى أحدث إصدار";
            
            alert(errorMessage);
        } finally {
            this.isUpdating = false;
        }
    },

    // ===== Add-region popup handlers =====
    openAddRegionPopup() {
      this.errors = {};
      this.newRegion = { countryCode: '', regionCode: '', regionNameAr: '', regionNameEn: '' };
      this.showAddRegionPopup = true;
    },
    closeAddRegionPopup() {
      this.showAddRegionPopup = false;
    },
    validateNewRegion() {
      this.errors = {};
      const nr = this.newRegion;
      if (!nr.countryCode) this.errors.countryCode = 'مطلوب';
      if (!nr.regionCode) this.errors.regionCode = 'مطلوب';
      if (!nr.regionNameAr) this.errors.regionNameAr = 'مطلوب';
      if (!nr.regionNameEn) this.errors.regionNameEn = 'مطلوب';
      return !Object.keys(this.errors).length;
    },
    async submitNewRegion() {
      if (!this.validateNewRegion()) return;
      try {
        const resp = await axios.post(
          process.env.VUE_APP_SERVICE_URL + url.master_Addregion,
          this.newRegion,
          { headers: { 'X-Authorization': localStorage.getItem('token') } }
        );
        this.masterRegionsList.push(new MasterRegionsDto(resp.data.result.data));
        this.closeAddRegionPopup();
        alert('تم إضافة المنطقة بنجاح!');
      } catch (e) {
        console.error(e);
        alert('فشل إضافة المنطقة.');
      }
    },
    // ---- athan-time handlers ----
    openAddAthanPopup() {
      this.athanErrors = {};
      this.newAthan = { 
        regionId: this.regionId || '', 
        prayerName: '', 
        prayerTime: '', 
        sessionStartAfter: null 
      };
      this.loadingPrayerTime = false;
      this.showAddAthanPopup = true;
    },
    async loadPrayerTimeForNewAthan() {
      // Only load if both region and prayer are selected
      if (!this.newAthan.regionId || !this.newAthan.prayerName) {
        this.newAthan.prayerTime = '';
        return;
      }

      this.loadingPrayerTime = true;
      try {
        // Fetch prayer time directly from Aladhan API
        const resp = await axios.get(
          `${process.env.VUE_APP_SERVICE_URL}${url.get_prayer_time_from_aladhan}${this.newAthan.regionId}/prayer-time/${this.newAthan.prayerName}`,
          { headers: { 'X-Authorization': localStorage.getItem('token') } }
        );

        if (resp.data?.result?.data?.prayerTime) {
          // Convert HH:mm:ss to HH:mm for time input
          const timeParts = resp.data.result.data.prayerTime.split(':');
          this.newAthan.prayerTime = `${timeParts[0]}:${timeParts[1]}`;
          console.log(`Fetched prayer time from Aladhan API: ${this.newAthan.prayerName} = ${this.newAthan.prayerTime}`);
        } else {
          // Prayer time not found
          this.newAthan.prayerTime = '';
          console.warn(`Prayer time not found for ${this.newAthan.prayerName} in region ${this.newAthan.regionId}`);
        }
      } catch (error) {
        console.error('Error loading prayer time from Aladhan API:', error);
        this.newAthan.prayerTime = '';
        // Show user-friendly error message
        if (error.response?.data?.result?.mesAr) {
          alert(`خطأ في جلب وقت الصلاة: ${error.response.data.result.mesAr}`);
        }
      } finally {
        this.loadingPrayerTime = false;
      }
    },
    getPrayerNameFromValue(value) {
      // Normalize prayer name for comparison
      const prayerMap = {
        'FAJR': 'الفجر',
        'DHUHR': 'الظهر',
        'ASR': 'العصر',
        'MAGHRIB': 'المغرب',
        'ISHA': 'العشاء'
      };
      return prayerMap[value] || value;
    },
    closeAddAthanPopup() {
      this.showAddAthanPopup = false;
    },
    validateNewAthan() {
      this.athanErrors = {};
      const a = this.newAthan;
      if (!a.regionId) this.athanErrors.regionId = 'مطلوب';
      if (!a.prayerName) this.athanErrors.prayerName = 'مطلوب';
      if (!a.prayerTime) this.athanErrors.prayerTime = 'مطلوب';
      if (!a.sessionStartAfter || a.sessionStartAfter < 1) this.athanErrors.sessionStartAfter = '>=1';
      // totalClass validation removed - session count is managed individually
      return !Object.keys(this.athanErrors).length;
    },
    async submitNewAthan() {
      if (!this.validateNewAthan()) return;
      try {
        // Prepare the request data with proper format
        const requestData = {
          prayer_name: this.newAthan.prayerName,
          prayer_time: this.newAthan.prayerTime + ':00', // Convert HH:mm to HH:mm:ss
          session_start_after: this.newAthan.sessionStartAfter || 0,
        };

        // Use regionId from newAthan (not from this.regionId)
        const regionId = this.newAthan.regionId;

        // Log the request for debugging
        console.log('Submitting new athan time:', {
          url: `${process.env.VUE_APP_SERVICE_URL + url.Add_athan_time}${regionId}`,
          data: requestData,
          regionId: regionId
        });

        await axios.post(
          `${process.env.VUE_APP_SERVICE_URL + url.Add_athan_time}${regionId}`,
          requestData,
          { 
            headers: { 
              'X-Authorization': localStorage.getItem('token'),
              'Content-Type': 'application/json'
            } 
          }
        );
        
        // Refresh the list to show the new athan time
        // If different region was selected, switch to it and reload
        if (this.regionId === regionId) {
          await this.getAllMasterAthan();
        } else {
          this.regionId = regionId;
          await this.getAllMasterAthan();
        }
        this.closeAddAthanPopup();
        alert('تم إضافة توقيت الأذان بنجاح!');
      } catch (e) {
        console.error('Error adding athan time:', e);
        let errorMessage = 'فشل إضافة توقيت الأذان.';
        
        if (e.response?.data?.result?.mesAr) {
          errorMessage = e.response.data.result.mesAr;
        } else if (e.response?.data?.message) {
          errorMessage = e.response.data.message;
        } else if (e.response?.data?.errors) {
          const errors = Object.values(e.response.data.errors).flat();
          errorMessage = errors.join(', ');
        }
        
        alert(errorMessage);
      }
    }
  }
  
});
</script>

<style scoped>
.button {
  @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-40 h-10;
}
</style>
